module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point05_05_sunset-33b9cd04c59e77f9f6c6bdf65724f3bf.jpg";